import {isNil, negate} from '@yandex-delivery/utils'

const filterPredicate = negate(isNil)

export function buildFieldName(...names: string[]) {
  return names.filter(filterPredicate).join('.')
}
